import { render } from "./BuilderInitialHoldModal.vue?vue&type=template&id=18d6f9d1&ts=true&lang=pug"
import script from "./BuilderInitialHoldModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderInitialHoldModal.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderInitialHoldModal.vue?vue&type=style&index=0&id=18d6f9d1&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__